import type { BrandConfig } from './types';

export const stratacor: BrandConfig = {
  key: 'stratacor',
  name: 'Stratacor',
  appTitle: 'Starship Command Center',
  appSubtitle: 'Command Center',

  colors: {
    primary: {
      50: '#e6f9fc',
      100: '#ccf3f9',
      200: '#99e7f3',
      300: '#66dbed',
      400: '#33cfe7',
      500: '#00AEC7',
      600: '#008b9f',
      700: '#006877',
      800: '#00464f',
      900: '#002327',
      950: '#001214',
    },
    secondary: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    accent: {
      50: '#f5f3f9',
      100: '#ebe7f3',
      200: '#d7cfe7',
      300: '#c3b7db',
      400: '#af9fcf',
      500: '#9b87c3',
      600: '#876fb7',
      700: '#7357ab',
      800: '#563D82',
      900: '#422f63',
      950: '#2e2144',
    },
    danger: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      950: '#450a0a',
    },
    warning: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      950: '#451a03',
    },
    success: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
      950: '#052e16',
    },
  },

  fonts: {
    sans: ['Manrope', 'system-ui', 'sans-serif'],
    mono: ['JetBrains Mono', 'Consolas', 'monospace'],
  },

  fontImports: [
    'https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&display=swap',
    'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600&display=swap',
  ],

  assets: {
    logo: 'brands/stratacor/logo.png',
    favicon: 'brands/stratacor/favicon.png',
  },

  chartColors: [
    '#00AEC7', // Stratacor Cyan (Primary)
    '#563D82', // Stratacor Purple (Accent)
    '#EF4444', // Red (Danger)
    '#F59E0B', // Amber (Warning)
    '#10B981', // Emerald (Success)
    '#008b9f', // Stratacor Cyan Dark
    '#33cfe7', // Stratacor Cyan Light
    '#7357ab', // Stratacor Purple Light
    '#06B6D4', // Cyan
    '#6B7280', // Gray
  ],
};
